// extracted by mini-css-extract-plugin
export var columnList = "_fi-0";